
import {
	formatNumberPlain,
} from '@/lib/helper';

export const getCommissionValue = (price, commissionPercentage = 5) => {
	const commission = commissionPercentage; // default 5%
	return price * commission / 100;
};

export const getMarginValue = (price, dropshipMargin = 0, type = 'percentage') => {
	let margin = dropshipMargin;
	if (type === 'percentage') {
		margin = price * (dropshipMargin / 100);
	}
	return margin;
};

export const elipsisPrice = (value) => {
	const price = formatNumberPlain(value);
	const splittedPrice = price.split('.');
	let censoredPrice = '';
	splittedPrice.forEach((val, index) => {
		if (index === 0) {
			censoredPrice += 'X'.repeat(val.length);
		} else {
			censoredPrice += `.${val}`;
		}
	});

	return `Rp${censoredPrice}`;
};
